import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { debounce, useGlobalState } from "senf-shared";
import { useIsMobile } from "../../../../hooks/customDeviceDetect";
import { useModals } from "../../../molecules/modalStack/ModalProvider";
import { checkIfPointInPolygon } from "../utils/checkIfPointInPolygon";
import { getCenterOfFeature } from "../utils/getCenterOfFeature";
import { reverseGeocode } from "../utils/reverseGeocode";

export function useGetLocation(
  statefulMap,
  project,
  ideaMap,
  geoDataType,
  formik,
  setLocation,
) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isOut, setOut] = useState(false);
  const { closeModal, openModal, isModalOpen } = useModals();
  const [centerOfPolygon, setCenterOfPolygon] = useState(null);
  const [statefulCesiumMap, setStatefulCesiumMap] =
    useGlobalState().statefulCesiumMap;
  const isCesiumMap = statefulCesiumMap && statefulCesiumMap.centerCoordinates;

  const checkIfIdeaIsInProject = async (viewport) => {
    const closeModalAndmoveToCenter = () => {
      closeModal({ id: "checkIfIdeaIsInProjectModal" });
      statefulMap.flyTo({
        center: [centerOfPolygon[0], centerOfPolygon[1]],
        duration: 1300,
        pitch: 30,
        padding: {
          top: 0,
          right: 0,
        },
      });
    };

    if (!checkIfPointInPolygon(viewport, ideaMap?.map?.mapbounds)) {
      setOut(true);
      // openModal(null, {
      //   title: t("dialogMap:add.cantAddIdeaOutsidea.projectroom.Title"),
      //   description: t(
      //     "dialogMap:add.cantAddIdeaOutsidea.projectroom.Description"
      //   ),
      //   swipe: !!isMobile,
      //   size: isMobile ? "full" : "md",
      //   submitText: t("dialogMap:add.bringBackToProjectroom"),
      //   id: "checkIfIdeaIsInProjectModal",
      //   onSubmit: () => closeModalAndmoveToCenter(),
      //   afterClose: () => closeModalAndmoveToCenter(),
      // });
    } else {
      if (isModalOpen("checkIfIdeaIsInProjectModal")) {
        closeModal({ id: "checkIfIdeaIsInProjectModal" });
      }
      setOut(false);
    }
  };

  const newViewport = useRef();
  const getLocation = debounce(async () => {
    newViewport.current = {
      latitude: isCesiumMap
        ? statefulCesiumMap?.centerCoordinates?.latitude
        : statefulMap.getCenter().lat,
      longitude: isCesiumMap
        ? statefulCesiumMap?.centerCoordinates?.longitude
        : statefulMap.getCenter().lng,
    };
    reverseGeocode(newViewport.current).then((l) => {
      formik.setFieldValue("address", l.address);
      setLocation(l);
    });
    checkIfIdeaIsInProject(newViewport.current);
  }, 700);

  useEffect(() => {
    if (geoDataType !== "location") {
      statefulMap?.off("moveend", getLocation);
      return;
    }

    const timer = setTimeout(() => {
      statefulMap?.on("moveend", getLocation);
    }, 2000);

    return () => {
      clearTimeout(timer);
      statefulMap?.off("moveend", getLocation);
    };
  }, [statefulMap, geoDataType]);

  useEffect(() => {
    if (statefulCesiumMap?.centerCoordinates) {
      getLocation();
    }
  }, [statefulCesiumMap?.centerCoordinates]);

  useMemo(() => {
    if (ideaMap?.map?.mapbounds) {
      setCenterOfPolygon(getCenterOfFeature(ideaMap?.map?.mapbounds));
    }
  }, [project]);

  return {
    isOut,
    checkIfIdeaIsInProject,
  };
}
